<template>
  <a-card :title="id?'编辑码券':'新建码券'" class="coupon-code-creator">
    <a-form-model
      :label-col="currentFormLayout.labelCol"
      :wrapper-col="currentFormLayout.wrapperCol"
      ref="form"
      :model="codeForm"
      :rules="rules"
    >
      <a-form-model-item label="码券名称" prop="name">
        <a-input :style="input_style" v-model="codeForm.name" placeholder="请输入" allowClear></a-input>
      </a-form-model-item>
      <a-form-model-item label="码券类型" prop="type">
        <a-radio-group v-model="codeForm.type" @change="onRadioChange">
          <a-radio value="DHQ">预约码</a-radio>
          <a-radio value="DZM">电子码</a-radio>
          <a-radio value="JHM">激活码</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="销售方式" prop="sellWay">
        <a-radio-group v-model="codeForm.sellWay">
          <a-radio value="OUT" v-if="codeForm.type!='JHM'">仅外部销售</a-radio>
          <a-radio value="IN">仅平台销售</a-radio>
          <a-radio value="ALL" v-if="codeForm.type!='JHM'">全网销售</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="使用方式" prop="useWay">
        <a-select v-model="codeForm.useWay" enable :style="input_style">
          <a-select-option value="PLATFORM">{{ codeForm.type === 'DZM' ? '平台核销' : '平台预约' }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="派发方式">
        <a-radio-group v-model="codeForm.distributeWay">
          <a-radio value="HAND">手动派发</a-radio>
          <a-radio v-if="codeForm.sellWay==='ALL'" value="AUTO_HAND">手动+自动派发</a-radio>
          <a-radio v-if="codeForm.sellWay==='IN'" value="AUTO">自动派发</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="发送条数" required style="margin-bottom: 0;"
                         v-if="codeForm.sellWay==='IN'||codeForm.sellWay==='ALL'">
        <a-col :span="5">
          <a-form-model-item>
            <a-select allowClear v-model="codeForm.sendNumber" placeholder="请选择">
              <a-select-option :value="0">仅一条</a-select-option>
              <a-select-option :value="1">买一送</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="15" class="pl5">
          <a-form-model-item v-if="codeForm.sendNumber==1" prop="freeNum">
            <a-input v-model="codeForm.freeNum" addonAfter="条" placeholder="1-5" :maxLength="1"
                     style="max-width:100px"/>
          </a-form-model-item>
        </a-col>
      </a-form-model-item>
      <a-form-model-item label="码券来源">
        <a-radio-group v-model="codeForm.source">
          <a-radio value="IN">平台生成</a-radio>
          <a-radio value="OUT">外部券码</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <div v-if="codeForm.source==='IN'">
        <a-form-model-item label="生成码数" prop="stockNum">
          <a-input :style="input_style" v-model="codeForm.stockNum" placeholder="请输入" allowClear></a-input>
        </a-form-model-item>
      </div>
      <a-form-model-item v-else label=" " :colon="false" prop="redeemCodeList">
        <a-textarea
          v-model="codeForm.redeemCodeList"
          :style="input_style"
          placeholder="每行一个，多个换行即可"
          :rows="6"></a-textarea>
      </a-form-model-item>
      <a-form-model-item label="关联商品" prop="proName">
        <div class="button-box">
          <a-button @click="toSelectedEvent">选择</a-button>
        </div>
        <div class="name-text" v-if="codeForm.proName">
          商品ID:{{ codeForm.proId }}&emsp;&emsp;商品名称:{{ codeForm.proName }}
        </div>
        <div class='name-text' v-if='codeForm.optionName'>
          套餐ID:{{ codeForm.optionId }}&emsp;&emsp;套餐名称:{{ codeForm.optionName }}
        </div>
      </a-form-model-item>
      <a-form-model-item label="激活人信息" v-if="codeForm.type=='JHM'">
        <LinkmanItem ref="linkMan" :contractMessage="codeForm.activateContractInfo"
                     :requiredList="codeForm.activateMustContractInfo"
                     @change="changeLinkMan"
        ></LinkmanItem>
      </a-form-model-item>
      <a-form-model-item label="有效期" :required="true">
        <a-select v-model="codeForm.timeType" :style="input_style">
          <a-select-option :value="1">长期有效</a-select-option>
          <a-select-option v-if="codeForm.type==='DHQ'||codeForm.type==='JHM'" :value="2">购买后</a-select-option>
          <a-select-option :value="3">自定义时间</a-select-option>
        </a-select>
        <a-form-model-item v-if="codeForm.timeType===2" style="display: inline-block;margin-left: 20px" prop="days">
          <a-input-number v-model="codeForm.days" :min="1" placeholder="请输入"></a-input-number>
          <span style="margin-left: 10px">天</span>
        </a-form-model-item>
        <a-form-model-item
          v-else-if="codeForm.timeType===3"
          style="display: inline-block;margin-left: 20px"
          prop="customDate">
          <a-range-picker :style="input_style" v-model="codeForm.customDate"></a-range-picker>
        </a-form-model-item>
      </a-form-model-item>
      <a-form-model-item label=" " :colon="false" style="margin-top: 40px">
        <a-button type="primary" @click="submitEvent()" :loading="saveLoading">提交</a-button>
        <a-button style="margin-left: 20px" @click="backEvent()">取消</a-button>
      </a-form-model-item>
    </a-form-model>
    <selected-product-dialog
      title="关联商品"
      ref="dialogTable"
      :show="showSelectedDialog"
      :itemNames="['search_name','search_proId']"
      :query-params="selectedQueryParams"
      :left-space="20"
      rowKey="id"
      :requestPromise="getListPromise"
      @close="showSelectedDialog=false"
      :columns="getProductColumns()"
    >
      <a-form-item
        slot="search_name"
        label="商品名称"
        :labelCol="{ span: 10 }"
        :wrapperCol="{ span: 14 }">
        <a-input
          v-model="selectedQueryParams.searchName"
          style="width: 170px"
          placeholder="请输入商品名称"
          allowClear
        ></a-input>
      </a-form-item>
      <a-form-item
        slot="search_proId"
        label="商品ID"
        :labelCol="{ span: 10 }"
        :wrapperCol="{ span: 14 }">
        <a-input
          v-model="selectedQueryParams.proId"
          style="width: 170px"
          placeholder="请输入商品ID"
          allowClear
        ></a-input>
      </a-form-item>
      <template slot="proTypeSlots" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button v-if="updateShowButton(rowItem.record)" type="primary" size='small'
                  @click="toSelectedResult(rowItem.record)">确认
        </a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import formMixin from '@/utils/mixins/formMixins'
import TagSelectOption from '@/components/TagSelect/TagSelectOption'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import LinkmanItem from '@/views/product/productGroup/components/LinkmanItem'

export default {
  name: 'CouponCodeCreator',
  components: { SelectedProductDialog, TagSelectOption, LinkmanItem },
  mixins: [formMixin],
  data() {
    return {
      input_style: { 'max-width': '400px' },
      id: this.getPageParams().id,
      selectedQueryParams: {
        couponType: 'DHQ'
      },
      currentFormLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 }
      },
      showDialog: false,
      codeForm: {
        name: '',
        type: 'DHQ',//类型(DHQ:预约码,DZM 电子码,YHQ:优惠券,ZKQ:折扣券,TGQ：团购券)
        sellWay: 'IN',//销售方式(IN:平台销售,OUT:外部)
        useWay: 'PLATFORM',//使用方式(PLATFORM:平台,OFFLINE:线下,THIRD:第三方)
        distributeWay: 'AUTO',//派发方式（AUTO:自动,HAND:手动  手动加自动 AUTO_HAND
        source: 'IN',//来源(IN:内部,OUT:外部)
        stockNum: '',
        redeemCodeList: '',
        timeType: 1,
        days: '',
        validStartTime: '',
        validEndTime: '',
        code: '',
        proId: 0,
        proName: '',
        optionId: '',
        optionName: '',
        customDate: undefined,
        sendNumber: 0,
        freeNum: '',//条数
        activateContractInfo: '',
        activateMustContractInfo: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入劵码名称', trigger: 'blur' }
        ],
        stockNum: [
          { required: true, message: '请输入生成码数', trigger: 'blur' },
          { pattern: /^([1-9]\d{0,3}|10000)$/, message: '请输入正确的生成码数', trigger: 'blur' }
        ],
        redeemCodeList: [
          { required: true, message: '请粘贴一行一码', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择券码类型', trigger: 'change' }
        ],
        sellWay: [
          { required: true, message: '请选择销售方式', trigger: 'change' }
        ],
        useWay: [
          { required: true, message: '请选择使用方式', trigger: 'change' }
        ],
        days: [
          { required: true, message: '请输入天数', trigger: 'blur' },
          { pattern: /^([1-9]\d{0,2}|1000)$/, message: '请输入正确的天数', trigger: 'blur' }
        ],
        customDate: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        freeNum: [
          { required: true, message: '请输入条数', trigger: 'blur' },
          { pattern: /^[1-5]$/, message: '输入1-5的整数', trigger: 'blur' }
        ],
        proName: [
          { required: true, message: '请选择商品', trigger: 'change' }
        ]
      },
      showSelectedDialog: false
    }
  },

  watch: {
    'codeForm.timeType': function(value) {
      if (value !== 3) {
        this.codeForm.customDate = undefined
      }
      if (value !== 2) {
        this.codeForm.days = 0
      }
    },
    'codeForm.sellWay': function(value) {
      if (value === 'ALL') {
        this.codeForm.distributeWay = 'AUTO_HAND'
      } else if (value === 'OUT') {
        this.codeForm.distributeWay = 'HAND'
        this.codeForm.sendNumber = 0
        this.codeForm.freeNum = ''//条数
      } else {
        this.codeForm.distributeWay = 'AUTO'
      }
    }

  },
  mounted() {
    this.id = this.getPageParams().id
    if (this.id) {
      this.getCodeInfo()
    }
  },
  methods: {
    updateShowButton(record) {
      if (record.proType == 8) {
        return true
      } else {
        if (record.mark == 1) {
          return false
        } else {
          return true
        }
      }
    },
    onRadioChange(e) {
      this.getLogUtils().logWithTag('radio checked', e.target.value)
      let value = e.target.value
      this.selectedQueryParams.couponType = value
      if (value == 'JHM') {
        this.codeForm.sellWay = 'IN'
        this.$nextTick(() => {
          this.$refs.linkMan.getLinkInfo(this.codeForm.activateContractInfo, this.codeForm.activateMustContractInfo)
        })
      }
      this.codeForm.proName = ''
      this.codeForm.proId = 0
      this.codeForm.proImg = ''
      this.codeForm.optionId = 0
      this.codeForm.optionName = ''
    },
    getCodeInfo() {
      this.getHttpServices().getCouponService().post('couponSetInfo/getCouponSetInfoById/' + this.id)
        .then(info => {
          this.getLogUtils().logWithTag('getCodeInfo', info)
          let dataForm = {
            ...info,
            validStartTime: undefined,
            validEndTime: undefined
          }
          if (info.validStartTime) {
            dataForm.customDate = this.getDateHelper().getDateMoments(info.validStartTime, info.validEndTime)
          }
          if (dataForm.redeemCodeList && dataForm.redeemCodeList.length > 0) {
            dataForm.redeemCodeList = dataForm.redeemCodeList.join('\n')
          }
          dataForm.sendNumber = dataForm.freeNum > 0 ? 1 : 0
          dataForm.activateContractInfo = dataForm.activateContractInfo ? dataForm.activateContractInfo : ''
          dataForm.activateMustContractInfo = dataForm.activateMustContractInfo ? dataForm.activateMustContractInfo : ''
          this.codeForm = dataForm
          this.$nextTick(() => {
            if (dataForm.type == 'JHM') {
              this.$refs.linkMan.getLinkInfo(this.codeForm.activateContractInfo, this.codeForm.activateMustContractInfo)
            }
          })
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    checkCodeList() {
      let list
      if (this.codeForm.redeemCodeList) {
        list = this.codeForm.redeemCodeList.split('\n')
      }
      if (this.codeForm.type == 'DZM' && this.codeForm.source == 'OUT' && list && list.length > 0) {
        for (var i = 0; i < list.length; i++) {
          if (isNaN(Number(list[i])) || list[i].length < 4 || list[i].length > 12) {
            this.$message.error('请输入4-12位纯数字券码')
            return false
          }
        }
      }
      return true
    },
    submitEvent() {
      this.$refs['form'].validate(valid => {
        if (valid && this.checkCodeList()) {
          this.requestUpdate()
        }
      })
    },
    changeLinkMan(data) {
      this.getLogUtils().logWithTag('changeLinkMan', data)
      this.codeForm.activateContractInfo = data.str
      let newMustContractInfo = ''
      if (data.requiredStr) {
        let list = ['1', '2', ...data.requiredStr.split(',')]
        newMustContractInfo = [...new Set(list)].join(',')
        this.codeForm.activateMustContractInfo = newMustContractInfo
      } else {
        this.codeForm.activateMustContractInfo = '1,2'
      }
    },
    requestUpdate() {
      this.saveLoading = true
      const tips = this.id ? '编辑成功' : '创建成功'
      const params = {
        ...this.codeForm,
        customDate: undefined,
        validStartTime: undefined,
        validEndTime: undefined
      }
      if (this.codeForm.type != 'JHM') {
        params.activateContractInfo = ''
        params.activateMustContractInfo = ''
      }
      if (this.codeForm.customDate && this.codeForm.customDate.length > 1) {
        params.validStartTime = this.getDateHelper().getFormatDate(this.codeForm.customDate[0])
        params.validEndTime = this.getDateHelper().getFormatDate(this.codeForm.customDate[1])
      }
      params.freeNum = this.codeForm.sendNumber == 1 ? params.freeNum : 0
      delete params.sendNumber
      this.getHttpServices().getCouponService().post('couponSetInfo/insertOrUpdateCouponSetInfo', params)
        .then(res => {
          this.$message.success(tips)
          setTimeout(() => this.backEvent(), 1000)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.saveLoading = false)
    },

    toSelectedEvent() {
      this.showSelectedDialog = true
      this.$refs.dialogTable.refresh(true)
    },
    toSelectedResult(record) {
      this.getLogUtils().logWithTag('==toSelectedResult==', record)
      if (record.mark == 1) {
        this.codeForm.proName = record.name
        this.codeForm.proId = record.id
        this.codeForm.proImg = record.proImg
        this.codeForm.optionId = 0
        this.codeForm.optionName = ''
      } else {
        this.codeForm.proName = record.proName
        this.codeForm.proId = record.proId
        this.codeForm.proImg = record.proImg
        this.codeForm.optionId = record.id
        this.codeForm.optionName = record.name
      }
      this.showSelectedDialog = false
      this.$refs.form.validateField('proName', (Error) => {
      })
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getApiService().post('api/product/getCouponProductPage', params)
    },
    getProductColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'id'
        },
        {
          title: '商品名称',
          dataIndex: 'name',
          width: '40%'
        },
        {
          title: '商品分类',
          dataIndex: 'proType',
          scopedSlots: { customRender: 'proTypeSlots' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }

}
</script>
<style lang="less" scoped>
.pl5 {
  padding-left: 5px;
}

.name-text {
  line-height: 25px;
}
</style>